import './MainDashboardIndex.less';
import {selectAuth} from '../../../redux/selectors';
import {connect} from 'react-redux';
import CampaignDashboardScreen from '../../Campaigns/CampaignDashboardScreen/CampaignDashboardScreen';
import PropTypes from 'prop-types';

const MainDashboardIndex = ({auth}) => {
  if (auth?.appContext === 'cmt') {
    return (
      <CampaignDashboardScreen />
    );
  }
};

MainDashboardIndex.propTypes = {
  auth: PropTypes.any,
};

const mapState = state => {
  const auth = selectAuth(state);
  return {auth};
};

export default connect(mapState)(MainDashboardIndex);
